import React from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import SubnavTabs from '../subnav_tabs/SubnavTabs';

type LifeCycleAnalyticsOverviewHeaderProps = {
	companyConfig: any;
	title?: string;
	isDetailView?: boolean;
};

const LifeCycleAnalyticsOverviewHeader = ({
	companyConfig,
	title = 'Lifecycle Analytics',
	isDetailView = false,
}: LifeCycleAnalyticsOverviewHeaderProps) => {
	const horizontalPaddingClasses = isDetailView ? 'pl-[41px] pr-6' : 'px-6';
	return (
		<div
			className={`-mx-4 mb-2 ${horizontalPaddingClasses} pb-0 pt-6`}
			style={{
				background: nullSafeGet('detail.config.theme.navblock', companyConfig),
			}}
		>
			<div className="mb-6">
				<h4 className="mb-0 mr-2 text-white/90">{title}</h4>
			</div>
			<SubnavTabs tabs={[]} onChange={() => {}} isActive={() => {}} />
		</div>
	);
};

export default LifeCycleAnalyticsOverviewHeader;
